import { ChangeBusinessDetails } from './ChangeBusinessDetails';

export class ChangeJagoTenantId extends ChangeBusinessDetails {
  type: string = 'ChangeJagoTenantId';
}
